import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { BakeasyLoaderReduxProp } from '../../components/loaders/BakeasyLoaderRedux';

const initialState: BakeasyLoaderReduxProp = { message: '', isLoading: false };

const loaderSlice = createSlice({
  name: 'loader',
  initialState,
  reducers: {
    showLoader(state, action: PayloadAction<BakeasyLoaderReduxProp>) {
      state.message = action.payload.message;
      state.isLoading = true;
    },
    hideLoader(state) {
      state.message = '';
      state.isLoading = false;
    }
  }
});

export const loaderState = (state: RootState) => state?.loader;
export const { showLoader, hideLoader } = loaderSlice.actions;
export default loaderSlice.reducer;
